import type { PipelineBoard, PipelineColumn } from '@/pages/pipelines/common/types';

import { normalizeInvestmentCardPresentation } from './normalize-card';

const INVESTMENT_COMPACT_STAGE_LABELS: Record<string, string> = {
  LinkClicked: 'Link clicked',
  DueDiligenceViewed: 'DD viewed',
  SubscriptionStarted: 'Sub. started',
  AgreementSigned: 'Agr. signed',
  FundsSent: 'Funds sent',
  NotEligible: 'Not eligible',
};

export const normalizeInvestmentBoardPresentation = (board: PipelineBoard): PipelineBoard => ({
  ...board,
  columns: board.columns.map((column) => ({
    ...column,
    compactLabel: getInvestmentCompactStageLabel(column),
    cards: column.cards.map((card) =>
      normalizeInvestmentCardPresentation(card, { faceIndicatorsOnly: true }),
    ),
  })),
});

const getInvestmentCompactStageLabel = (column: Pick<PipelineColumn, 'stage' | 'label'>) =>
  INVESTMENT_COMPACT_STAGE_LABELS[column.stage] ?? column.label;
